// extracted by mini-css-extract-plugin
module.exports = {"container":"simple-modal_component_container__ZoD3Q","content":"simple-modal_component_content__HBEqB"};